import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_Uploader = _resolveComponent("Uploader")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: `${_ctx.accountAppItem.id ? '编辑' : '创建'}应用`,
    modelValue: _ctx.selfVisible,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selfVisible) = $event)),
    "close-on-press-escape": false,
    "close-on-click-modal": false,
    "custom-class": "dialog-width-small",
    center: "",
    top: "5vh",
    onClose: _ctx.close
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_el_button, {
          size: "default",
          onClick: _ctx.close
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 取 消 ")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          type: "primary",
          size: "default",
          onClick: _ctx.handleSave
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 确 定 ")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        inline: false,
        "label-width": "130px",
        rules: _ctx.rules,
        model: _ctx.formData,
        ref: "ruleForm",
        size: "default"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "应用名称",
            prop: "appName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.appName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.appName) = $event)),
                modelModifiers: { trim: true },
                maxlength: "20",
                placeholder: "请输入应用名称"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "应用编码",
            prop: "appCode"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.appCode,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.appCode) = $event)),
                modelModifiers: { trim: true },
                maxlength: "20",
                placeholder: "请输入应用编码",
                disabled: !!_ctx.accountAppItem.id
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "应用logo",
            prop: "appLogo"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Uploader, {
                class: "uploder-100",
                multiple: "",
                modelValue: _ctx.appLogoList,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.appLogoList) = $event)),
                paste: true,
                size: "mini",
                limit: 1,
                beforeUpload: (file) => _ctx.checkFile(file, '.png, .jpg, .jpeg'),
                accept: ".png, .jpg, .jpeg",
                tips: "最多可以上传1张图片，支持png、jpg、jpeg图片格式"
              }, null, 8, ["modelValue", "beforeUpload"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "更新维度",
            prop: "updateDimension"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.updateDimension,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.updateDimension) = $event)),
                placeholder: "请选择更新维度",
                style: {"width":"100%"},
                onChange: _ctx.handleChangeDimension,
                disabled: !!_ctx.accountAppItem.id
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.UPDATE_DIMENSION_LIST, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: index,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "onChange", "disabled"])
            ]),
            _: 1
          }),
          _withDirectives(_createVNode(_component_el_form_item, {
            label: "用户体系",
            prop: "dataChannel"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.dataChannel,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.dataChannel) = $event)),
                placeholder: "请选择用户体系",
                style: {"width":"100%"},
                disabled: !!_ctx.accountAppItem.id
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.USER_SYSTEM_LIST, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: index,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 512), [
            [_vShow, _ctx.formData.updateDimension === _ctx.UPDATE_DIMENSION_ENUM.DEPARTMENT]
          ]),
          _createVNode(_component_el_form_item, {
            label: "适配系统",
            prop: "adaptiveSystem"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.adaptiveSystem,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.adaptiveSystem) = $event)),
                placeholder: "请选择适配系统",
                style: {"width":"100%"},
                multiple: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ADAPTATION_SYSTEM_LIST, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: index,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _withDirectives(_createVNode(_component_el_form_item, {
            label: "Android下载地址",
            prop: "androidAddress"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.androidAddress,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.androidAddress) = $event)),
                modelModifiers: { trim: true },
                maxlength: "200",
                placeholder: "请输入Android下载地址"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 512), [
            [_vShow, _ctx.formData.adaptiveSystem.includes(_ctx.ADAPTATION_SYSTEM_ENUM.android)]
          ]),
          _withDirectives(_createVNode(_component_el_form_item, {
            label: "IOS下载地址",
            prop: "iosAddress"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.iosAddress,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.iosAddress) = $event)),
                modelModifiers: { trim: true },
                maxlength: "200",
                placeholder: "请输入IOS下载地址"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 512), [
            [_vShow, _ctx.formData.adaptiveSystem.includes(_ctx.ADAPTATION_SYSTEM_ENUM.ios)]
          ])
        ]),
        _: 1
      }, 8, ["rules", "model"])
    ]),
    _: 1
  }, 8, ["title", "modelValue", "onClose"]))
}